import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MCBarSkeletonComponent, MCButtonComponent } from '@maslul/common-components';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MCTranslationStateService } from '@maslul/common-services';

@Component({
    selector: 'mi-home',
    templateUrl: './home.html',
    styleUrl: './home.scss',
    standalone: true,
    imports: [
        CommonModule,
        MCButtonComponent,
        MCBarSkeletonComponent
    ],
    encapsulation: ViewEncapsulation.None,
})
//todo: use page base and use navigate
export class HomeComponent implements OnInit, OnDestroy {

    subscribtion: Subscription = new Subscription()
    genericText: any;
    public translationsLoaded$: Observable<boolean>;

    constructor(private router: Router
        , private translateService: TranslateService
        , private translationStateService: MCTranslationStateService) {
        this.translationsLoaded$ = this.translationStateService.translationsLoaded$;
    }

    ngOnInit() {
        this.initText();

    }

    initText() {
        this.subscribtion.add(this.translateService.stream('generic').subscribe(translation => {
            this.genericText = translation;
        }));
    }


    enter() {
        this.router.navigate(['/request-submission-methods'])
    }

    ngOnDestroy(): void {
        this.subscribtion.unsubscribe();
    }
}
